import { PASSWORD } from "../../../constants/fields";

const config = {
  email: {
    label: "E-mail",
    validationRules: [{ required: true, message: "Please enter E-mail!" }],
    type: "email",
    placeholder: "E-mail",
  },
  password: {
    type: PASSWORD,
    label: "Password",
    placeholder: "Password",
    validationRules: [
      { required: true, message: "Please input password!" },
      { min: 6, message: "The field must be at least 6 characters!" },
    ],
  },
};

export default config;
